import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import React from 'react';
//import Service1 from '../../common/Services/Service1';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import { SaoPauloTitle } from '../../common/Title/SaoPauloTitle';
// import { Service1 } from '../../common/Services/Service1';
// //import { about1 } from '../../common/Destination/Destination1';
// //import aboutBanner from '/assets/company/company-banner.webp';
// //import aboutusLeft from '/assets/company/aboutus.webp';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';


const ChilebusAboutUs = () => {
	const operator = CommonService.getLocal('op');


	const ChilebusServiceItems = [
		{
			icon: '/assets/company/flag.svg',
			text: 'Nuestra visión',
			body:
				'Ofrecer la mejor y moderna opción de transporte de pasajeros en la región, asegurando un buen servicio, con puntualidad, seguridad, confort y cortesía, poniendo a disposición del público la flota más moderna de la región con buses de primera línea.',
		},
		{
			icon: '/assets/company/heart.svg',
			text: 'Nuestros valores',
			body:
				'La honestidad, humildad, responsabilidad y compromiso con nuestros clientes es lo que nos impulsa cada día a ser mejores para entregar un servicio de calidad por medio de un personal competente y comprometido con la organización.',
		},
	];

	const createMarkup = (data) => {
		return { __html: data };
	}


	return (
		<div className="" style={{ marginTop: 150 }}>
			<HeroSection
				heroImage={'/assets/company/company-banner.webp'}
				// height={'30vh'}
				// height={'50vh'}
				title={'La empresa'}
				description={'Home / La empresa'}
			/>
			hhhhhhhhhhhhhhhh
			Lorem ipsum dolor sit amet consectetur adipisicing elit. At, odit vitae deleniti ratione aperiam est dolores. Ad maxime a earum fugiat consequuntur omnis asperiores eum amet, accusamus vel, tempore illo ex in, dolor nulla doloremque quidem reiciendis accusantium adipisci sit. Commodi debitis animi in reiciendis. Harum voluptas nisi quo enim saepe laboriosam.
			<div className="new-container">
				{/* <SaoPauloTitle title={'Conoce acerca de nosotros'} operator={operator} /> */}
				<div style={{ display: 'flex', marginTop: 20, marginBottom: 20 }}>
					<div style={{ width: '40%' }}>
						<img src={'/assets/company/aboutus.webp'} />
					</div>
					<div className="font12" style={{ width: '60%', paddingLeft: 30, lineHeight: 1.3 }}>
						<div dangerouslySetInnerHTML={createMarkup(operator.about_us.split('///')[0])} className='lh-1-3' />
						{/* Buses Sao Paulo está delicado a satisfacer al cliente con un servicio de calidad,
            fijando su atención en la seguridad y comodidad de los pasajeros, logrando que su viaje
            sea placentero, lo que nos hace diferentes. Nuestros buses se someten a programas de
            mantenimiento constante, se efectúan revisiones de rutina en las unidades para asegurar
            un viaje sin contratiempos. La empresa de Buses Sao Paulo se encuentra ubicada en
            Coyhaique, puerta de entrada para descubrir las maravillas naturales de la Patagonia
            Chilena. Somos una empresa con más de 30 años de experiencia en el rubro del transporte
            de pasajeros y nos hemos caracterizado por un constante crecimiento y modernización,
            principalmente en nuestra flota, especialmente equipados, lo cual nos permite garantizar
            la excelencia de nuestro servicio en todo momento. Nuestra amplia gama de oferta incluye
            una flota de 12 Buses que van de los 25 a 45 pasajeros, todos equipados con aire
            acondicionado, butacas reclinables soft, calefacción, micrófonos, música ambiental y
            mucho más. */}
					</div>
				</div>

				{/* <div>
					<Service1
						operator={operator}
						sectionHeading={'Ofrecemos un servicio de calidad'}
						items={ChilebusServiceItems}
						boldTitle={true}
					/>
				</div> */}

				{/* <div style={{ marginTop: 30 }}>
					<img src={historyBanner} />
				</div> */}
				<div className="font12" style={{ marginTop: 30, lineHeight: 1.3 }}>
					<div dangerouslySetInnerHTML={createMarkup(operator.about_us.split('///')[1])} className='lh-1-3' />
					{/* Buses Sao Paulo, es una empresa familiar con más de 30 años de experiencia en el rubro,
          pero el amor por los buses comenzó mucho antes, cuando el jefe de hogar trabajaba como
          conductor de buses de empresas de la región. Su sueño era tener su propio bus para
          independizarse y así fue, en el año 1993 compró su primer minibús, una Toyota Hiace año
          1980, con la cual inició su aventura, realizando recorridos urbanos hacia las poblaciones
          del sector alto de la ciudad de Coyhaique, fue complejo, era tierra de nadie, pero
          seguimos adelante y dio sus frutos. Con el pasar de los años se adquirió el primer bus,
          una Mitsubishi Rosa, fue un tremendo logro como familia, este fue el bus que inició y
          ayudó a construir la empresa que tenemos en la actualidad. Así pasaron los años y se
          ampliaron los servicios a trabajar con recorridos subsidiados hacia localidades remotas y
          aisladas como Villa La Tapera, Estancia Cisnes, Emperador Guillermo, Seis Lagunas y entre
          otras, siempre brindando y ofreciendo un servicio de calidad para los pasajeros. En la
          actualidad se cuenta con una flota de 12 buses, y hemos ido ampliando nuestros servicios,
          los que son, rurales, escolares, privados y turismo. Los años nos avalan, llevamos más de
          10 años con recorridos rurales hacia localidades como Cochrane y Puerto Cisnes, así como
          atendiendo a importantes servicios, trasladando a sus funcionarios todos los días del año
          por más de 10 años consecutivos. */}

				</div>
			</div>
		</div>
	);
};



function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ChilebusAboutUs); 


// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/Chilebus/ChilebusAboutus.js